import React from 'react'

class Location {
    regions = {}

    constructor() {
    }

    getCountries() {
        if (!this.countries)
            return fetch(`?plugin=dp&module=backend&action=getCountries`, {
                credentials: 'include'
            })
                .then(r => {
                    return r.json()
                })
                .then(r => {
                    let countries = r.data.map(data => {
                        return {value: data.iso3letter, label: data.name}
                    })

                    this.countries = countries

                    return countries
                })
        else return Promise.resolve(this.countries)
    }

    getRegions(country) {
        if (!this.regions[country])
            return fetch(`?plugin=dp&module=backend&action=getRegions&country=${country}`, {
                credentials: 'include'
            })
                .then(r => {
                    return r.json()
                })
                .then(r => {
                    let regions = r.data.map(data => {
                        return {value: data.code, label: data.name}
                    })

                    this.regions[country] = regions

                    return regions
                })
        else return Promise.resolve(this.regions[country])
    }
}

export default Location
